import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {Notification} from './notifications/notifications.model';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {MatSnackBar} from "@angular/material/snack-bar";


@Injectable({providedIn: 'root'})
export class SharedService {

  notificationSubject: Subject<Notification> = new Subject<Notification>();
  progressVisibilitySubject: Subject<boolean> = new Subject<boolean>();

  constructor(private http: HttpClient,
              private snackBar: MatSnackBar) {
  }

  showNotification(notification: Notification) {
    this.notificationSubject.next(notification);
  }

  showLoadingOverlay() {
    this.progressVisibilitySubject.next(true);
  }

  hideLoadingOverlay() {
    this.progressVisibilitySubject.next(false);
  }

  getLanguages(){
    return this.http.get< { [key: string]: string } >(environment.apiUrl + 'groups/languages');
  }

  showToast(message: string, type: 'error' | 'success'): void {
    let panelClass = 'success-snackbar';
    if (type === 'error') {
      panelClass = 'error-snackbar';
    }
    this.snackBar.open(message, '',
      {
        duration: 2000,
        verticalPosition: 'top',
        panelClass: panelClass
      });
  }
}
